/* tslint:disable */
/* eslint-disable */
/**
 * PR TIMES Proofreading API
 * PR TIMES 校正 API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * POST /main
 * POST /lint
 * @export
 * @interface ProofreadingRequestBody
 */
export interface ProofreadingRequestBody {
    /**
     * 校正する文字列のリスト(example：['title', 'subtitle', '<p>body text</p>'])
     * @type {Array<string>}
     * @memberof ProofreadingRequestBody
     */
    bulkText: Array<string>;
}

export function ProofreadingRequestBodyFromJSON(json: any): ProofreadingRequestBody {
    return ProofreadingRequestBodyFromJSONTyped(json, false);
}

export function ProofreadingRequestBodyFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProofreadingRequestBody {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'bulkText': json['bulk_text'],
    };
}

export function ProofreadingRequestBodyToJSON(value?: ProofreadingRequestBody | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'bulk_text': value.bulkText,
    };
}

